import * as P from "../../node_modules/.pnpm/three@0.172.0/node_modules/three/build/three.tsl.js";
import { getAspectCorrectedCoordinates as Z } from "../../utilities/uv.js";
import { grain as $ } from "../../helpers/grain.js";
import { distort as oo } from "../../helpers/distort.js";
import { glow as to } from "../../helpers/glow.js";
import { edgeMask as no } from "../../helpers/edgeMask.js";
const ao = {
  name: "ChromaticSoft3",
  collection: "chromatic-soft",
  tags: ["wave", "gradient"],
  props: {
    speed: {
      type: Number,
      default: 1,
      description: "The speed of the wave effect."
    }
  },
  fragmentNode: (m) => {
    const {
      vec3: E,
      vec4: l,
      time: O,
      mix: n,
      sin: T,
      float: o,
      pow: c,
      uv: N,
      color: t
    } = P, _ = t("#ff7c94"), S = t("#f1987d"), p = t("#eadb73"), u = t("#ffd895"), C = t("#bf2828"), R = t("#f18a36"), D = -0.5, G = 2, I = 0, L = 0, g = 0.2, A = 0.5, b = 4, F = 0.1, v = 0.05, w = 1, U = 0.6, Y = 0.5, x = 1, V = 2, s = N(), { correctedUV: W } = Z(), a = oo(s, g, A, b), h = c(_, o(2.2)), y = c(S, o(2.2)), B = c(p, o(2.2)), k = c(u, o(2.2)), H = n(
      h,
      y,
      s.x
    ), K = n(
      k,
      B,
      s.x
    ), Q = n(
      H,
      K,
      s.y
    ), d = a.x.sub(0.5), f = a.y.sub(0.5), X = f.mul(d).add(f.mul(d)).negate(), r = o(1).add(
      o(F).mul(
        T(
          X.add(O.mul(m.speed.uniform).mul(0.025)).div(v)
        )
      )
    ), z = no({
      inset: D,
      softness: G,
      offsetX: I,
      offsetY: L
    }), M = E(r, r, r).mul(z).mul(w), j = n(
      R,
      C,
      s.y
    ), i = $(U)(W), e = Q.mul(M).add(i), q = e.r.add(e.g).add(e.b), J = l(
      n(j.add(i), e, q),
      1
    );
    return to(J, _, Y, x, V);
  }
};
export {
  ao as componentDefinition,
  ao as default
};
